import { render, staticRenderFns } from "./SlRelaunch.vue?vue&type=template&id=38a054c8&scoped=true&lang=html&"
import script from "./SlRelaunch.vue?vue&type=script&lang=js&"
export * from "./SlRelaunch.vue?vue&type=script&lang=js&"
import style0 from "./SlRelaunch.vue?vue&type=style&index=0&id=38a054c8&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a054c8",
  null
  
)

export default component.exports